// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://tkenconmtxyxkwvzciiy.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRrZW5jb25tdHh5eGt3dnpjaWl5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDA2MDA3NTIsImV4cCI6MjA1NjE3Njc1Mn0.T_X8sjugblorFs4XtiQxB8AC9l60ZCvDt-o5kx0mujU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);